import type { RootState } from '/business/shared/state/store';

export default (state: RootState) => {
  return state.language?.language || 'en';
};
